module.exports = __webpack_public_path__ + "img/lock.229e5a4f.svg";